/*
 * Privacy Consent Text Component
 * Shows privacy policy and terms & conditions acceptance text
 */
import React from 'react'

import {Text} from '@chakra-ui/react'

import {msgf, useTranslationHelpers} from '@epmc-mach/accelarator/overrides/app/hooks'

import Link from '/overrides/app/components/link'

const PrivacyConsentText = () => {
    const {tShipping} = useTranslationHelpers()

    return (
        <Text fontSize="sm">
            {msgf(tShipping?.textConsentMessage, [
                <Link
                    key={tShipping?.textPrivacy}
                    color="blue"
                    href={tShipping?.linkPrivacy}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {tShipping?.textPrivacy}
                </Link>,
                <Link
                    key={tShipping?.textTerms}
                    color="blue"
                    href={tShipping?.linkTerms}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {tShipping?.textTerms}
                </Link>,
                tShipping?.linkWithdrawal && (
                    <Link
                        key={tShipping?.textWithdrawal}
                        color="blue"
                        href={tShipping?.linkWithdrawal}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {tShipping?.textWithdrawal}
                    </Link>
                )
            ])}
        </Text>
    )
}

export default PrivacyConsentText
